export const FORM_FIELD_SELECT = 3;
export const CALENDAR = 4;
export const COLUMNS_POPUP = 5;
export const MENU = 6;
export const POPUP = 99;
export const NOTIFICATIONS = 100;
